import gql from "graphql-tag";

const InterestCheckProps = gql`
    fragment InterestCheckProps on InterestCheckList {
        id
        action_plans
        created_at
        creatives {
            activity
            interest
            participation
        }
        educational {
            activity
            interest
            participation
        }
        health_fitness {
            activity
            interest
            participation
        }
        leisures {
            activity
            interest
            participation
        }
        out_about {
            activity
            interest
            participation
        }
        out_door {
            activity
            interest
            participation
        }
        productivity {
            activity
            interest
            participation
        }
        short_list
        strong_interest
        social {
            activity
            interest
            participation
        }
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        sports {
            activity
            interest
            participation
        }
    }
`;

export const NEW_INTEREST_CHECKLIST = gql`
    mutation NewInterestChecklist($model: InterestCheckListInput!) {
        RecordNewInterestCheckList(model: $model) {
            message
            doc {
                ...InterestCheckProps
            }
        }
    }
    ${InterestCheckProps}
`;

export const GET_INTEREST_CHECKLIST = gql`
    query GetInterestChecklist($patient: ID!) {
        GetPatientInterestCheckLists(patient: $patient) {
            docs {
                ...InterestCheckProps
            }
        }
    }
    ${InterestCheckProps}
`;
